import React from 'react';
import type { LexerHandlerKey, LexerToken, LexerHandlerMap, LexerLoader, extraOptions } from './typings/index';
import { pluralLangMap } from './utils/lang_map';

export default function lexerHandler(
  str: string,
  lang: string,
  loaders: Partial<Record<LexerHandlerKey, LexerLoader['handle']>>,
  map?: LexerHandlerMap,
  options?: extraOptions
): React.ReactNode[] | React.ReactNode {
  const pluralLang = pluralLangMap(lang);
  const handlerMapKeys = map ? Object.keys(map) : [];
  // 0. 如果没有存在特殊的词法规则业务处理逻辑则直接return纯文本
  if (!map || !handlerMapKeys.length) {
    return str;
  }

  // 1. 获取到的 raw string 初始化成一个LexerToken数组
  let result: LexerToken[] = [
    {
      type: 'text',
      raw: str || '',
      content: str || '',
    },
  ];

  // 2. 优先处理starling下发的特殊复数变量，复数变量不存在特殊的语法
  if (/{num, plural, (.+?)}/.test(str)) {
    if (loaders.plural) {
      return loaders.plural(result, pluralLang, map.plural)[0].content!;
    } else {
      return str;
    }
  }

  // 3. 根据传入的LexerHandlerMap进行解析, 将解析完成后的结果, 使用业务定义的lexerhandler进行处理
  result = (function recursive(r): LexerToken[] {
    if (!handlerMapKeys.length) {
      return r;
    }
    const key = handlerMapKeys.pop() as LexerHandlerKey;
    return recursive(loaders[key] ? loaders[key](r, map[key]) : r);
  })(result);

  if (options?.lexerResultReturnRawText) {
    return result.map(i => i.content).join('');
  }

  // 4. 返回处理之后的结果 React.ReactNode 或者 是纯文本节点
  return result.length ? result.map((r, i) => <span key={i}>{r.content}</span>) : result;
}
